import * as React from 'react';
import PropTypes from 'prop-types';
import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { Button, MenuItem, Divider } from '@mui/material';
import StyledMenu from './styles/StyledMenu';
import ColorBox from './styles/ColorBox';

export default function CustomMenu({ buttonIcon, menuItems, selectedItemId, itemCallback }) {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    event.preventDefault();
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
  };
  const handleClose = (event) => {
    event.preventDefault();
    event.stopPropagation();
    setAnchorEl(null);
  };

  return (
    <div>
      {buttonIcon ? (
        <Button
          id="demo-customized-button"
          aria-controls={open ? 'demo-customized-menu' : undefined}
          aria-haspopup="true"
          aria-expanded={open ? 'true' : undefined}
          variant="text"
          disableElevation
          onClick={handleClick}
          endIcon={<KeyboardArrowDownIcon />}
          size="small"
        >
          {buttonIcon}
        </Button>
      ) : (
        <IconButton
          id="demo-customized-button"
          aria-controls={open ? 'demo-customized-menu' : undefined}
          aria-haspopup="true"
          aria-expanded={open ? 'true' : undefined}
          variant="contained"
          onClick={handleClick}
        >
          <MoreVertIcon />
        </IconButton>
      )}
      <StyledMenu
        id="demo-customized-menu"
        MenuListProps={{
          'aria-labelledby': 'demo-customized-button',
        }}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        align={menuItems?.length ? 'left' : undefined}
        minwidth={menuItems?.length ? 0 : 180}
      >
        {menuItems?.length
          ? [
              <MenuItem
                key={0}
                disableRipple
                selected={!selectedItemId}
                disabled={!selectedItemId}
                onClick={(event) => {
                  itemCallback?.();
                  handleClose(event);
                }}
              >
                <ColorBox />
                Не выбрано
              </MenuItem>,
              ...menuItems.map((vehicle) => (
                <MenuItem
                  key={vehicle.id}
                  disableRipple
                  selected={selectedItemId === vehicle.registrationNum}
                  disabled={selectedItemId === vehicle.registrationNum}
                  onClick={(event) => {
                    itemCallback?.(vehicle);
                    handleClose(event);
                  }}
                >
                  <ColorBox color={vehicle.color} />
                  {vehicle.registrationNum}
                </MenuItem>
              )),
            ]
          : [
              <MenuItem key={1} onClick={handleClose} disableRipple>
                <EditIcon />
                Редактировать
              </MenuItem>,
              <Divider key={2} sx={{ my: 0.5 }} />,
              <MenuItem key={3} sx={{ color: 'red' }} onClick={handleClose} disableRipple>
                <DeleteIcon style={{ color: 'red' }} />
                Удалить
              </MenuItem>,
            ]}
      </StyledMenu>
    </div>
  );
}
CustomMenu.propTypes = {
  buttonIcon: PropTypes.element.isRequired,
  menuItems: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  itemCallback: PropTypes.func.isRequired,
  selectedItemId: PropTypes.string.isRequired,
};
